import axiosInstance from '@/plugins/api/axiosInstance';

export default function quickbooks() {
    return {
        tokenInfo,
        storeToken,
        authorizationUrl,
        deleteToken,
        syncBill
    };

    function tokenInfo() {
        return axiosInstance.get('quickbooks/token-info');
    }

    function storeToken(data) {
        return axiosInstance.post('quickbooks/store-token', data);
    }

    function authorizationUrl() {
        return axiosInstance.get('quickbooks/authorization-url');
    }

    function deleteToken() {
        return axiosInstance.delete('quickbooks/delete-token');
    }

    function syncBill(billId) {
        return axiosInstance.get(`quickbooks/sync-bill?id=${billId}`);
    }
}
